/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Grid } from '@mui/material';
import { Tooltip } from '@mui/material';
import {
  CustomLabel,
  CustomSwitch,
} from 'components/Common/MUIStyledComponents';
import { CircularProgress } from '@mui/material';
import ToolBreadcrumb from 'components/Common/ToolBreadcrumb';
import { getMonitorListSearch } from 'utils/monitorListSearch';

interface IHeaderLayoutProps {
  children?: React.ReactNode;
  title: string;
  helpContent?: any;
  handleTooltipClick?: () => void;
  handleDeleteClick?: () => void;
  handleFavorite?: any;
  fav?: boolean;
  handleCSV?: any;
  handleOpenShareModal?: any;
  shareModal: boolean;
  setShareModal?: any;
  downloadModal: boolean;
  setDownloadModal?: any;
  cur_case: any;
  userHasMonitor?: boolean;
  isNotification: boolean;
  handleSwitchChange?: any;
  totalComments?: any;
  triggerCSV?: boolean;
  triggerSendPdf?: boolean;
  handleRescreen?: any;
  triggerRescreen?: boolean;
  showRescreen?: boolean;
}

const AuditHeaderLayout: React.FC<IHeaderLayoutProps> = (
  props: IHeaderLayoutProps,
) => {
  const {
    children,
    title,
    helpContent,
    handleTooltipClick,
    handleDeleteClick,
    handleFavorite,
    fav,
    handleCSV,
    handleOpenShareModal,
    shareModal,
    setShareModal,
    downloadModal,
    setDownloadModal,
    cur_case,
    userHasMonitor,
    isNotification,
    handleSwitchChange,
    totalComments,
    triggerCSV,
    triggerSendPdf,
    handleRescreen,
    triggerRescreen,
    showRescreen,
  } = props;

  const runDownload = () => {
    // Tariff picks PDF/CSV; Beneficial Ownership picks the report or its
    // one-page visual summary.
    if (
      cur_case.data.docType === 'Tariff' ||
      cur_case.data.docType === 'Beneficial Ownership'
    ) {
      setDownloadModal(!downloadModal);
    } else {
      handleCSV();
    }
  };

  return (
    <section
      className='home-content-body Home-HeaderDown'
      style={{ minHeight: 0 }}
    >
      <Grid container>
        <Grid item xs={12}>
          <div className='module-header'>
            <ToolBreadcrumb
              items={[
                {
                  label: 'Saved Work',
                  // Resumes the list with whatever filters/page/view it had
                  // when the user left it, instead of a plain reset.
                  to: `/bite-monitor${getMonitorListSearch()}`,
                },
                { label: title },
              ]}
            />
            <div className='module-header-breadcrumbs'>
              <h1 className='analyzers-page-title'>{title}</h1>
              {helpContent && (
                <div className='module-header-btns'>
                  <Tooltip
                    title={helpContent}
                    placement='bottom-start'
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          display: 'flex',
                          padding:
                            'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          alignSelf: 'stretch',
                          borderRadius: 'var(--radius-md, 8px)',
                          background: 'var(--Background-200, var(--bg-colors))',
                          color: 'var(--text-prim25)',
                          maxWidth: '700px',
                          '& .MuiTooltip-arrow': {
                            color: 'var(--Background-200, var(--bg-colors))',
                          },
                        },
                      },
                    }}
                  >
                    <div className='module-header-help'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                      >
                        <g clipPath='url(#clip0_16034_866)'>
                          <path
                            d='M7.57484 7.50001C7.77076 6.94306 8.15746 6.47343 8.66647 6.17428C9.17547 5.87514 9.77392 5.76579 10.3558 5.8656C10.9377 5.96541 11.4655 6.26794 11.8457 6.71961C12.226 7.17128 12.4341 7.74294 12.4332 8.33334C12.4332 10 9.93317 10.8333 9.93317 10.8333M9.99984 14.1667H10.0082M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10Z'
                            stroke='#94969C'
                            strokeWidth='1.66667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_16034_866'>
                            <rect width='20' height='20' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      <p>Help</p>
                    </div>
                  </Tooltip>
                  <div
                    className='module-header-title-conts'
                    style={{ margin: 0 }}
                  >
                    {/* <h1>{title}</h1> */}
                    <div className='module-header-help' style={{ gap: '20px' }}>
                      <p>Enable Notifications</p>
                      <CustomLabel
                        control={
                          <CustomSwitch
                            checked={isNotification}
                            onChange={handleSwitchChange}
                            name='ticket'
                          />
                        }
                      />
                    </div>
                    <Tooltip
                      title={'Starred'}
                      placement='bottom-start'
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            display: 'flex',
                            padding:
                              'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            alignSelf: 'stretch',
                            borderRadius: 'var(--radius-md, 8px)',
                            background:
                              'var(--Background-200, var(--bg-colors))',
                            color: 'var(--text-prim25)',
                            maxWidth: '700px',
                            '& .MuiTooltip-arrow': {
                              color: 'var(--Background-200, var(--bg-colors))',
                            },
                          },
                        },
                      }}
                    >
                      <div className='audit-btn-star' onClick={handleFavorite}>
                        {fav ? (
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                          >
                            <path
                              d='M9.40253 2.8778C9.59461 2.48869 9.69064 2.29413 9.82102 2.23197C9.93445 2.17789 10.0662 2.17789 10.1797 2.23197C10.31 2.29413 10.4061 2.48869 10.5981 2.8778L12.4204 6.56944C12.4771 6.68432 12.5054 6.74176 12.5469 6.78635C12.5836 6.82584 12.6276 6.85783 12.6764 6.88056C12.7316 6.90623 12.795 6.91549 12.9218 6.93402L16.9978 7.5298C17.427 7.59253 17.6417 7.6239 17.741 7.72874C17.8274 7.81995 17.868 7.94529 17.8516 8.06985C17.8327 8.21302 17.6773 8.36436 17.3666 8.66702L14.4182 11.5387C14.3263 11.6282 14.2803 11.673 14.2507 11.7263C14.2244 11.7734 14.2076 11.8252 14.2011 11.8788C14.1937 11.9393 14.2046 12.0025 14.2263 12.129L14.922 16.1851C14.9953 16.6129 15.032 16.8269 14.9631 16.9538C14.9031 17.0642 14.7965 17.1417 14.6729 17.1646C14.5308 17.1909 14.3388 17.0899 13.9546 16.8879L10.3106 14.9716C10.1971 14.9119 10.1403 14.882 10.0805 14.8703C10.0276 14.8599 9.97311 14.8599 9.92015 14.8703C9.86034 14.882 9.80358 14.9119 9.69004 14.9716L6.0461 16.8879C5.66192 17.0899 5.46984 17.1909 5.3278 17.1646C5.20423 17.1417 5.09759 17.0642 5.03761 16.9538C4.96866 16.8269 5.00535 16.6129 5.07872 16.1851L5.7744 12.129C5.79609 12.0025 5.80693 11.9393 5.79959 11.8788C5.7931 11.8252 5.77625 11.7734 5.75 11.7263C5.72034 11.673 5.67439 11.6282 5.58248 11.5387L2.63412 8.66702C2.32338 8.36436 2.168 8.21302 2.1491 8.06985C2.13265 7.94529 2.17329 7.81995 2.2597 7.72874C2.35902 7.6239 2.57363 7.59253 3.00286 7.5298L7.07892 6.93402C7.20568 6.91549 7.26906 6.90623 7.32426 6.88056C7.37313 6.85783 7.41713 6.82584 7.45381 6.78635C7.49525 6.74176 7.5236 6.68432 7.5803 6.56944L9.40253 2.8778Z'
                              fill='#4895EF'
                              stroke='#4895EF'
                              strokeWidth='1.66667'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                          >
                            <path
                              d='M8.46199 2.58993C8.63485 2.23972 8.72128 2.06462 8.83862 2.00867C8.94071 1.96 9.05931 1.96 9.1614 2.00867C9.27874 2.06462 9.36517 2.23972 9.53804 2.58993L11.178 5.9124C11.2291 6.01579 11.2546 6.06748 11.2919 6.10762C11.3249 6.14316 11.3645 6.17195 11.4085 6.1924C11.4582 6.21551 11.5152 6.22384 11.6293 6.24052L15.2977 6.77672C15.684 6.83318 15.8772 6.86141 15.9666 6.95577C16.0444 7.03786 16.0809 7.15066 16.0661 7.26277C16.0491 7.39162 15.9093 7.52782 15.6296 7.80022L12.9761 10.3848C12.8934 10.4653 12.852 10.5056 12.8253 10.5535C12.8017 10.596 12.7865 10.6426 12.7807 10.6908C12.7741 10.7453 12.7838 10.8022 12.8034 10.916L13.4295 14.5665C13.4955 14.9516 13.5285 15.1441 13.4665 15.2583C13.4125 15.3577 13.3165 15.4274 13.2053 15.448C13.0775 15.4717 12.9046 15.3808 12.5588 15.199L9.27928 13.4743C9.1771 13.4206 9.12601 13.3937 9.07218 13.3832C9.02452 13.3738 8.9755 13.3738 8.92784 13.3832C8.87402 13.3937 8.82293 13.4206 8.72074 13.4743L5.44119 15.199C5.09544 15.3808 4.92256 15.4717 4.79473 15.448C4.68351 15.4274 4.58754 15.3577 4.53355 15.2583C4.4715 15.1441 4.50452 14.9516 4.57056 14.5665L5.19666 10.916C5.21618 10.8022 5.22594 10.7453 5.21934 10.6908C5.21349 10.6426 5.19833 10.596 5.1747 10.5535C5.14802 10.5056 5.10666 10.4653 5.02394 10.3848L2.37042 7.80022C2.09075 7.52782 1.95091 7.39162 1.93389 7.26277C1.91909 7.15066 1.95567 7.03786 2.03344 6.95577C2.12283 6.86141 2.31598 6.83318 2.70228 6.77672L6.37073 6.24052C6.48482 6.22384 6.54186 6.21551 6.59154 6.1924C6.63552 6.17195 6.67512 6.14316 6.70814 6.10762C6.74543 6.06748 6.77095 6.01579 6.82198 5.9124L8.46199 2.58993Z'
                              stroke='var(--card-text)'
                              strokeWidth='1.5'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            />
                          </svg>
                        )}
                      </div>
                    </Tooltip>
                    <Tooltip
                      title={'Share'}
                      placement='bottom-start'
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            display: 'flex',
                            padding:
                              'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            alignSelf: 'stretch',
                            borderRadius: 'var(--radius-md, 8px)',
                            background:
                              'var(--Background-200, var(--bg-colors))',
                            color: 'var(--text-prim25)',
                            maxWidth: '700px',
                            '& .MuiTooltip-arrow': {
                              color: 'var(--Background-200, var(--bg-colors))',
                            },
                          },
                        },
                      }}
                    >
                      <div
                        className='audit-btn-star'
                        onClick={() => handleOpenShareModal?.()}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                        >
                          <path
                            d='M7.15833 11.2587L12.85 14.5753M12.8417 5.42533L7.15833 8.74199M17.5 4.16699C17.5 5.5477 16.3807 6.66699 15 6.66699C13.6193 6.66699 12.5 5.5477 12.5 4.16699C12.5 2.78628 13.6193 1.66699 15 1.66699C16.3807 1.66699 17.5 2.78628 17.5 4.16699ZM7.5 10.0003C7.5 11.381 6.38071 12.5003 5 12.5003C3.61929 12.5003 2.5 11.381 2.5 10.0003C2.5 8.61961 3.61929 7.50033 5 7.50033C6.38071 7.50033 7.5 8.61961 7.5 10.0003ZM17.5 15.8337C17.5 17.2144 16.3807 18.3337 15 18.3337C13.6193 18.3337 12.5 17.2144 12.5 15.8337C12.5 14.4529 13.6193 13.3337 15 13.3337C16.3807 13.3337 17.5 14.4529 17.5 15.8337Z'
                            stroke='var(--card-text)'
                            strokeWidth='1.66667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                      </div>
                    </Tooltip>

                    <Tooltip
                      title={'Comments'}
                      placement='bottom-start'
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            display: 'flex',
                            padding:
                              'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            alignSelf: 'stretch',
                            borderRadius: 'var(--radius-md, 8px)',
                            background:
                              'var(--Background-200, var(--bg-colors))',
                            color: 'var(--text-prim25)',
                            maxWidth: '700px',
                            '& .MuiTooltip-arrow': {
                              color: 'var(--Background-200, var(--bg-colors))',
                            },
                          },
                        },
                      }}
                    >
                      <div
                        className='audit-btn-star'
                        style={{ position: 'relative' }}
                        onClick={handleTooltipClick}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                        >
                          <path
                            d='M2.5 6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V11C17.5 12.4001 17.5 13.1002 17.2275 13.635C16.9878 14.1054 16.6054 14.4878 16.135 14.7275C15.6002 15 14.9001 15 13.5 15H8.06979C7.54975 15 7.28972 15 7.04101 15.051C6.82036 15.0963 6.60683 15.1712 6.40624 15.2737C6.18014 15.3892 5.9771 15.5517 5.57101 15.8765L3.58313 17.4668C3.23639 17.7442 3.06302 17.8829 2.91712 17.8831C2.79022 17.8832 2.67019 17.8255 2.59102 17.7263C2.5 17.6123 2.5 17.3903 2.5 16.9463V6.5Z'
                            stroke='var(--card-text)'
                            strokeWidth='1.66667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                        <span className='comment-badge'>{totalComments}</span>
                      </div>
                    </Tooltip>

                    <Tooltip
                      title={'Delete'}
                      placement='bottom-start'
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            display: 'flex',
                            padding:
                              'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            alignSelf: 'stretch',
                            borderRadius: 'var(--radius-md, 8px)',
                            background:
                              'var(--Background-200, var(--bg-colors))',
                            color: 'var(--text-prim25)',
                            maxWidth: '700px',
                            '& .MuiTooltip-arrow': {
                              color: 'var(--Background-200, var(--bg-colors))',
                            },
                          },
                        },
                      }}
                    >
                      <div
                        className='audit-btn-star'
                        onClick={handleDeleteClick}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                        >
                          <path
                            d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167'
                            stroke='var(--card-text)'
                            strokeWidth='1.66667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                      </div>
                    </Tooltip>
                    <button
                      className='btn-new-automate'
                      onClick={() => runDownload()}
                    >
                      <div>
                        {triggerCSV && (
                          <CircularProgress
                            style={{
                              width: '20px',
                              height: '20px',
                              marginRight: '10px',
                            }}
                            color='primary'
                          />
                        )}
                        Download
                      </div>
                    </button>
                    {showRescreen && (
                      <button
                        className='btn-new-automate-secondary'
                        onClick={() => handleRescreen && handleRescreen()}
                        disabled={triggerRescreen}
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {triggerRescreen ? (
                            <CircularProgress
                              style={{
                                width: '20px',
                                height: '20px',
                                marginRight: '10px',
                              }}
                              color='primary'
                            />
                          ) : (
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='18'
                              height='18'
                              viewBox='0 0 24 24'
                              fill='none'
                              style={{ marginRight: '8px' }}
                            >
                              <polyline
                                points='23 4 23 10 17 10'
                                stroke='var(--action-color)'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                              <polyline
                                points='1 20 1 14 7 14'
                                stroke='var(--action-color)'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                              <path
                                d='M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15'
                                stroke='var(--action-color)'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                            </svg>
                          )}
                          Re-screen
                        </div>
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>{children}</div>
      </Grid>
    </section>
  );
};

export default AuditHeaderLayout;
